import { InitializePaddleOptions } from "@paddle/paddle-js";
import { App } from "vue";
import { PADDLE_INJECTION_KEY, PADDLE_TOKEN } from "./constants";
import { PaddlePlugin } from "./interface";
import { PaddleImplementation } from "./plugin";
import { inject } from "vue";

declare module 'vue' {
  interface ComponentCustomProperties {
    [PADDLE_TOKEN]: PaddlePlugin;
  }
}

export function createPaddle(initializeOptions: InitializePaddleOptions) {
  return new PaddleImplementation(initializeOptions)
}

export function usePaddle() {
  return inject(PADDLE_INJECTION_KEY) as PaddlePlugin
}
